import { render, staticRenderFns } from "./RoleDrawerNotificationsTab.vue?vue&type=template&id=037607cc&scoped=true&"
import script from "./RoleDrawerNotificationsTab.vue?vue&type=script&lang=js&"
export * from "./RoleDrawerNotificationsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "037607cc",
  null
  
)

export default component.exports